import { escape } from 'lodash';

window.arjoWebinarListModule =
  window.arjoWebinarListModule ||
  (() => {
    const state = {
      isInitialized: false,
      elements: {},
    };

    const classNamePrefix = 'arjo-o-webinar-list';

    const setUp = () => {
      const elements = [...document.querySelectorAll(`.${classNamePrefix}`)];
      elements.forEach((element) => {
        const id = element.dataset.listId;

        let innerState = {
          domNode: element,
          filterByLv1Category: undefined,
          filterByLv2Category: undefined,
          filterByLv1Label: undefined,
          filterByLv2Label: undefined,
          data: [],
        };

        const setData = (data) => {
          innerState.data = [...data];
        };

        // get webinar url by country
        const getWebinarUrlByCountry = (webinar, country) => {
          if (!webinar.localUrls) {
            return webinar.url;
          }

          return (
            webinar.localUrls[`${country}-${country}`] ||
            webinar.localUrls[`${'en'}-${country}`] ||
            webinar.localUrls[`${webinar.languageCodes && webinar.languageCodes.filter((v) => v !== 'en' && v !== country)[0]}-${country}`]
          );
        };

        // get webinar url
        const getWebinarUrl = (webinar, element) => {
          if (!webinar.localUrls) {
            return webinar.url;
          }

          let language = element.parentElement.querySelector('.arjo-m-dropdown__options-input[name="language"]:checked')?.value;
          let country = element.parentElement.querySelector('.arjo-m-dropdown__options-input[name="country"]:checked')?.value;
          let newUrl;

          switch (true) {
            case !!language && !!country:
              newUrl = webinar.localUrls[`${language}-${country}`] || getWebinarUrlByCountry(webinar, country);
              break;
            case !!language && !country:
              newUrl = webinar.countryCodes && webinar.localUrls[`${language}-${webinar.countryCodes[0]}`];
              break;
            case !language && !!country:
              newUrl = getWebinarUrlByCountry(webinar, country);
              break;
          }

          return newUrl || webinar.url;
        };

        const createCardHtml = (webinar) => {
          /* webinar schemar
          {
            imageUrl: "https://qbank.arjo.com/webassets/IMG_5487_Story Portrait.jpg",
            headerText: "Hygiene Care: Preventing conflict and improving care for people living with dementia",
            bodyText: "The steps in the hygiene process can be overwhelming to a patient or resident with dementia often leading to distressing behaviour and moments of conflict with caregivers. ",
            category: ["Dementia"],
            date: "September 21 | 2021",
            url: "/int/academy/webinar/sem-scanner-technology-evaluating-economic-outcomes-in-pi-prevention/",
            isPastWebinar: true,
            badge: "Past Webinar",
            "video": {
              "videoId": "u279k1286d",
              "isPopover": true,
              "stillUrl": "https://qbank.arjo.com/webassets/IMG_5487_Story%20Portrait.jpg"
            },
            cta: {
              text: "Sign up to watch the webinar",
              icon: "/assets/images/icons.svg#arjo-ico-caret-outline-circle",
            },
          };
          */
          const badgeContent = [];

          webinar.languageNames && badgeContent.push(...webinar.languageNames);

          // calculation url
          const webinarUrl = getWebinarUrl(webinar, element);
          // end calculation url

          const headLeftHtml = `<div class="arjo-o-webinar-card__left">${webinar.badge}</div>`;
          const badgeHtml = badgeContent.length ? `<div class="arjo-o-webinar-card__badge">${badgeContent.join(' | ')}</div>` : '';
          const ctaHtml = webinar.cta
            ? `
              ${webinar.cta.text}&nbsp;
              <svg class="arjo-a-icon " aria-hidden="true">
                <use xlink:href="${webinar.cta.icon}"></use>
              </svg>
            `
            : '';
          const categoryHtml = (() => {
            let result = '';
            webinar.category.forEach((val, idx) => {
              if (idx === 0) {
                result = result.concat(val);
              } else {
                result = result.concat(', ', val);
              }
            });
            return result;
          })();

          const wistiaVideoHtml = (() => {
            const video = webinar.video;
            if (!video) return '';
            const className = `
              wistia_embed autoPlay=${video.autoPlay ? 'true' : 'false'} wistia_async_${video.videoId} stillUrl=${
                video.stillUrl ? 'true' : 'false'
              } popover=${video.isPopover ? 'true' : 'false'}
            `;

            return `
              <div class="arjo-o-webinar-card__video">
                <div class="arjo-a-wistia-video" data-id="${video.videoId}" data-popover="true">
                  <div class="wistia_responsive_padding">
                    <div class="wistia_responsive_wrapper">
                      <div class="${className}">
                      </div>
                    </div>
                  </div>
                  <script src="https://fast.wistia.com/embed/medias/${video.videoId}.jsonp" async></script>
                </div>
              </div>
            `;
          })();

          return `
            <div class="arjo-o-webinar-card ${!headLeftHtml && !badgeHtml ? 'arjo-o-webinar-card--no-badge' : ''}">
              <div
                class="arjo-o-webinar-card__container"
                onmousedown="window.arjoWebinarCardModule.onCardMouseDownHandler(event);"
                onclick="window.arjoWebinarCardModule.cardClickHandler(event);"
              >
                ${
                  headLeftHtml || badgeHtml
                    ? `<div class="arjo-o-webinar-card__head">
                  ${headLeftHtml}
                  ${badgeHtml}
                </div>`
                    : ''
                }
                <div class="arjo-o-webinar-card__image-container">
                  <img class="arjo-o-webinar-card__image" src="${webinar.imageUrl}" loading="lazy">
                </div>
                <div class="arjo-o-webinar-card__content">
                  <div class="arjo-o-webinar-card__category">
                    ${categoryHtml}
                  </div>
                  <h5 class="arjo-o-webinar-card__title">
                    <a class="arjo-o-webinar-card__link" href="${webinarUrl}" data-header-text="${escape(webinar.headerText)}">
                        ${webinar.headerText}
                    </a>
                  </h5>
                  <div class="arjo-o-webinar-card__date">
                    <svg class="arjo-a-icon arjo-a-icon--s"
                      aria-hidden="true"
                      viewBox="0 0 19 19"
                      width="19"
                      height="19">
                      <use xlink:href="/assets/images/icons.svg#arjo-ico-calendar"></use>
                    </svg>

                    ${webinar.date}
                  </div>
                  <div class="arjo-o-webinar-card__description">
                    ${webinar.bodyText}
                  </div>
                  <div class="arjo-o-webinar-card__cta">
                    ${ctaHtml}
                  </div>
                </div>
                ${wistiaVideoHtml}
              </div>
            </div>
          `;
        };

        const updateDom = () => {
          let dataForRender = [...innerState.data];

          const grid = innerState.domNode.querySelector(`.${classNamePrefix}__grid`);
          const cards = grid.querySelectorAll('.arjo-o-webinar-card');
          cards.forEach((card) => {
            card.remove();
          });

          dataForRender.forEach((data) => {
            grid.innerHTML += createCardHtml(data);
          });
        };

        const setState = (newState) => {
          innerState = { ...innerState, ...newState };
          updateDom();
        };

        const getState = () => {
          return {
            filterByLv1Category: innerState.filterByLv1Category,
            filterByLv2Category: innerState.filterByLv2Category,
            filterByLv1Label: innerState.filterByLv1Label,
            filterByLv2Label: innerState.filterByLv2Label,
            dropdowns: innerState.dropdowns,
            data: innerState.data,
          };
        };

        state.elements[id] = {
          setData,
          setState,
          get currentState() {
            return getState();
          },
        };
      });
    };

    const init = () => {
      if (state.isInitialized) return;
      setUp();
      state.isInitialized = true;
    };

    const getElement = (id) => {
      return state.elements[id];
    };

    return { init, getElement };
  })();

window.addEventListener('load', window.arjoWebinarListModule.init);
